/// <reference path="logging.module.ts" />

module Meevo.Components.Logging {

  export class LoggingService implements ILoggingService {

    constructor(private logLevel: LogLevel) {
    }

    get isTraceEnabled(): boolean {
      return this.logLevel <= LogLevel.Trace;
    }

    trace(message: string): void;
    trace(message: string, error: Error): void;
    trace(message: string, error?: Error): void {
      if (!this.isTraceEnabled) {
        return;
      }
      if (console != undefined && console.debug != undefined) {
        console.debug(this.getMessage(LogLevel.Trace, message, error));
      }
    }

    get isDebugEnabled(): boolean {
      return this.logLevel <= LogLevel.Debug;
    }

    debug(message: string): void;
    debug(message: string, error: Error): void;
    debug(message: string, error?: Error): void {
      if (!this.isDebugEnabled) {
        return;
      }
      if (console != undefined && console.debug != undefined) {
        console.debug(this.getMessage(LogLevel.Debug, message, error));
      }
    }

    get isInfoEnabled(): boolean {
      return this.logLevel <= LogLevel.Info;
    }

    info(message: string): void;
    info(message: string, error: Error): void;
    info(message: string, error?: Error): void {
      if (!this.isInfoEnabled) {
        return;
      }
      if (console != undefined && console.info != undefined) {
        console.info(this.getMessage(LogLevel.Info, message, error));
      }
    }

    get isWarnEnabled(): boolean {
      return this.logLevel <= LogLevel.Warn;
    }

    warn(message: string): void;
    warn(message: string, error: Error): void;
    warn(message: string, error?: Error): void {
      if (!this.isWarnEnabled) {
        return;
      }
      if (console != undefined && console.warn != undefined) {
        console.warn(this.getMessage(LogLevel.Warn, message, error));
      }
    }

    get isErrorEnabled(): boolean {
      return this.logLevel <= LogLevel.Error;
    }

    error(message: string): void;
    error(message: string, error: Error): void;
    error(message: string, error?: Error): void {
      if (!this.isErrorEnabled) {
        return;
      }
      if (console != undefined && console.error != undefined) {
        console.error(this.getMessage(LogLevel.Error, message, error));
      }
    }

    get isFatalEnabled(): boolean {
      return this.logLevel <= LogLevel.Fatal;
    }

    fatal(message: string): void;
    fatal(message: string, error: Error): void;
    fatal(message: string, error?: Error): void {
      if (!this.isFatalEnabled) {
        return;
      }
      if (console != undefined && console.error != undefined) {
        console.error(this.getMessage(LogLevel.Fatal, message, error));
      }
    }

    private getMessage(logLevel: LogLevel, message: string, error?: Error): string {
      return `${LogLevel[logLevel]} | ${message} ${(error == undefined ? "" : "\n\t" + error) }`;
    }

    static factory(): Function {
      let svc = () => {
        return new LoggingService(LogLevel.Trace);
      }

      return svc;
    }

  }

  angular.module("meevo.components.logging")
    .factory("meevo.components.logging.LoggingService", LoggingService.factory());
}